import BaseModel from '../vendor/baseModel'

export class CrossSell extends BaseModel {
  constructor() {
    super({
      url: 'cross_sell_items',
      name: 'crossSell',
      page_size: 'all'
    })
  }
}
